import React, { useState } from "react";
import { errorNoti } from "../../../../base/BasicNotifications";
import EbCompleteReviewModal from "../../ExecutionBlueprint/ExecutionBlueprintReview/CompleteReviewModal";
import useAnnualOkrReviewStore, {
  useAnnualOkrReviewStoreSelector,
} from "./_redux/AnnualOkrReviewStore";

// ═══════════════════════════════════════════════════════════════════════════
// "Complete review & send to CEO" for Annual OKRs.
//
// ⚠️ THIS IS A WRAPPER, NOT A SECOND MODAL. The Execution Blueprint's
// `CompleteReviewModal` is a presentational component whose submit body is
// ALREADY §6.7's exact shape — `note_to_ceo`, `scheduled_date`,
// `scheduled_time`, `duration_minutes` — because the two handoffs describe the
// same payload. Reusing it is what makes the two review screens identical by
// construction rather than by eye, and it inherits the date presets, the
// picker fields and the duration input's `type="text"` handling for free.
//
// An earlier pass here hand-rolled a simpler modal with a checkbox and three
// bare inputs. It looked nothing like the blueprint's, which is what this file
// exists to stop happening again. Two defaulted props (`title`, `itemNoun`)
// were added to the shared component for the wording; nothing else changed
// there, so every Execution Blueprint call site is untouched.
//
// What this wrapper owns is the CALL: the §6.7 POST, its 409 (whose message
// carries the count of Objectives still missing a decision) and its 400 on a
// bad date/time combination.
// ═══════════════════════════════════════════════════════════════════════════

const selectSubmitting = (state) => state.submitLoading;

const CompleteReviewModal = ({
  uniqueId,
  totalObjectives,
  acceptedCount,
  toDiscussCount,
  commentCount,
  onClose,
}) => {
  const submitting = useAnnualOkrReviewStoreSelector(selectSubmitting);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (body) => {
    if (sent) return;
    try {
      await useAnnualOkrReviewStore.getState().submitReview(uniqueId, body);
      setSent(true);
      onClose();
    } catch (error) {
      // Surfaced as a notification rather than inline: the shared modal has no
      // error slot, and adding one would change a component four Execution
      // Blueprint screens depend on. The server's own message is the useful
      // text here — §6.7's 409 names how many Objectives are still undecided.
      errorNoti(
        error.response?.data?.message ||
          "Could not send the review. Please try again.",
      );
    }
  };

  return (
    <EbCompleteReviewModal
      title="Review complete"
      itemNoun="Objective"
      totalItems={totalObjectives}
      acceptedCount={acceptedCount}
      toDiscussCount={toDiscussCount}
      commentCount={commentCount}
      submitting={submitting}
      onCancel={onClose}
      onSubmit={handleSubmit}
    />
  );
};

export default CompleteReviewModal;
